var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 7.399a.56.56 0 0 0 0-.795l-3-3.002a.562.562 0 0 0-.795.795l2.04 2.039-5.768.002A.56.56 0 0 0 4.749 7c0 .312.251.563.563.563h5.768L9.04 9.602a.562.562 0 0 0 .795.795zM4.937 2.875a.561.561 0 1 0 0-1.125H3.062c-1.14 0-2.063.924-2.063 2.063v6.375c0 1.139.924 2.062 2.063 2.062h1.875a.561.561 0 1 0 0-1.125H3.062a.937.937 0 0 1-.938-.937V3.813c0-.518.42-.938.938-.938z"
  })));
};
export default SvgLogOut;